import { Box, TextNew } from '@jfs/ui-new'
import { styles } from './styles'
import { itemSelected } from './types'
interface RadioButtonDropdownInterface {
  data: any
  onDropdownItemPress: (itemSelected: itemSelected) => void
  selectedValue?: string
}

export const DefaultDropDown = ({ data, onDropdownItemPress, selectedValue = '' }: RadioButtonDropdownInterface) => {
  return (
    <Box {...styles.mainView}>
      {data?.map((item: any) => {
        return (
          <Box {...styles.defaultDropdown} onPress={() => onDropdownItemPress(item)}>
            <TextNew {...styles.defaultTextStyle} color={selectedValue === item.value ? 'PRIMARY' : 'LIGHT_BLACK'}>
              {item?.value ?? ''}
            </TextNew>
          </Box>
        )
      })}
    </Box>
  )
}
